import { ErrorMessage } from "./ErrorMessage";
import { type AuthorizationHookResult } from "./useAuthorization";

export function AuthorizationErrorMessage(props: AuthorizationHookResult) {
  if (props.authorized) {
    return null; // No error message if authorized
  }

  return (
    <ErrorMessage
      message="You do not have permission to view this page."
      title="Restricted"
      level="warning"
    />
  );
}
